import dotenv from 'dotenv'
dotenv.config()

import Vue from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
// import Antd from 'ant-design-vue';

Vue.config.productionTip = false

Vue.use(VueGtag,{
  config: { id:'UA-160008530-1' }
});

// Vue.use(Antd)

new Vue({
  render: h => h(App),
}).$mount('#app')
